import {
  ApiStateRecord,
  appInsights
} from '@exxonmobil/uit-uda-ui-components-lib';
import {
  WorkCenterBaseline,
  WorkCenterBaselineResponse
} from 'models/baselines';

/*
  Takes the response of the api. Merges the current state of the record with the response.
  Sets isSelected to false on the merged record.
  Updates the main state array element with the merged record. 

  Used by: approveSelected, rejectSelected
*/
export const updateRecord = async (
  updatedWorkCenterBaseline: WorkCenterBaseline,
  workCenterBaselineElement: WorkCenterBaseline,
  currentState: ApiStateRecord<WorkCenterBaseline[]>
) => {
  const mergedBaseline = {
    ...workCenterBaselineElement,
    ...updatedWorkCenterBaseline
  };

  mergedBaseline.isSelected = false;

  const indexOfWorkCenterBaselineToUpdate = currentState.state.data.findIndex(
    (element) => element.workCenter === updatedWorkCenterBaseline.workCenter
  );

  currentState.state.data.splice(
    indexOfWorkCenterBaselineToUpdate,
    1,
    mergedBaseline
  );
};

// The results can contain records of status 'fulfilled' or 'rejected'
// 'rejected' means the API call probably failed
// 'fulfilled' means the API call succeeded
// Take the 'fulfilled' results and deserialize the WorkCenterBaseline results.
// Utilize those results to update the old state with the new state from the API.
export const handleAllUpdatesToApi = (
  results: PromiseSettledResult<Response>[],
  currentState: ApiStateRecord<WorkCenterBaseline[]>
) => {
  const selectedBaselines = currentState.state.data.filter((b) => b.isSelected);
  let responseStatus = 200;
  const fulfilledResponses = results
    .filter((result) => result.status === 'fulfilled')
    .map((result) => {
      const fulfilledResult = result as PromiseFulfilledResult<Response>;
      return fulfilledResult.value as Response;
    });

  const errors = fulfilledResponses.filter(
    (response) => response.status !== 200
  );
  if (errors.length > 0) {
    responseStatus = errors[0].status;
  }

  const jsonDeserializePromises = fulfilledResponses
    .filter((response) => response.status === 200)
    .map((response) => response.json() as Promise<WorkCenterBaselineResponse>);

  Promise.all(jsonDeserializePromises)
    .then((workCenterBaselineReponses) => {
      workCenterBaselineReponses.forEach(
        (updatedWorkCenterBaselineResponse) => {
          // This element should always exist and only one match should occur
          // Take the first 1 of 1 matches
          const workCenterBaselineElement = selectedBaselines.filter(
            (selectedBaseline) =>
              selectedBaseline.id === updatedWorkCenterBaselineResponse.value.id
          )[0];

          // Edit the record with the new value from API
          updateRecord(
            updatedWorkCenterBaselineResponse.value,
            workCenterBaselineElement,
            currentState
          );
        }
      );

      currentState.setState({
        ...currentState.state,
        loading: false,
        responseStatus
      });
    })
    .catch((reason) =>
      appInsights.trackTrace({ message: `rejectSelected: ${reason}` })
    );

  return results;
};
